import { Routes } from '@angular/router';
import { authGuard, guestGuard, reportAccessGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent), canActivate: [guestGuard] },
  { path: 'register', loadComponent: () => import('./components/register/register.component').then(m => m.RegisterComponent), canActivate: [guestGuard] },
  {
    path: 'reports',
    loadComponent: () => import('./components/sidebar/sidebar.component').then(m => m.SidebarComponent),
    canActivate: [reportAccessGuard],
    children: [
      { path: ':id', loadComponent: () => import('./components/document-detail/document-detail.component').then(m => m.DocumentDetailComponent) },
      { path: ':id/screening', loadComponent: () => import('./components/screening-notes/screening-notes.component').then(m => m.ScreeningNotesComponent) },
      { path: ':id/screening-results', loadComponent: () => import('./components/screening-results-v2/screening-results-v2.component').then(m => m.ScreeningResultsV2Component) },
      { path: ':id/email-template', loadComponent: () => import('./components/email-template/email-template.component').then(m => m.EmailTemplateComponent) }
    ]
  },
  {
    path: 'report',
    loadComponent: () => import('./components/sidebar/sidebar.component').then(m => m.SidebarComponent),
    canActivate: [reportAccessGuard],
    children: [
      { path: ':id', loadComponent: () => import('./components/document-detail/document-detail.component').then(m => m.DocumentDetailComponent) },
      { path: ':id/screening', loadComponent: () => import('./components/screening-notes/screening-notes.component').then(m => m.ScreeningNotesComponent) },
      { path: ':id/screening-results', loadComponent: () => import('./components/screening-results-v2/screening-results-v2.component').then(m => m.ScreeningResultsV2Component) },
      { path: ':id/email-template', loadComponent: () => import('./components/email-template/email-template.component').then(m => m.EmailTemplateComponent) }
    ]
  },
  {
    path: '',
    loadComponent: () => import('./components/sidebar/sidebar.component').then(m => m.SidebarComponent),
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'manuscript-setup', pathMatch: 'full' },
      { path: 'dashboard', loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent) },
      // { path: 'manuscript-setup', loadComponent: () => import('./components/manuscript-setup/manuscript-setup.component').then(m => m.ManuscriptSetupComponent) },
      { path: 'manuscript-setup', loadComponent: () => import('./components/upload/upload.component').then(m => m.UploadComponent) },
      { path: 'upload', loadComponent: () => import('./components/upload-files/upload-files.component').then(m => m.UploadFilesComponent) },
      { path: 'documents', loadComponent: () => import('./components/reports/reports.component').then(m => m.ReportsComponent) },
      { path: 'documents/retry', loadComponent: () => import('./components/reports/reports.component').then(m => m.ReportsComponent) },
      { path: 'documents/:id', loadComponent: () => import('./components/document-detail/document-detail.component').then(m => m.DocumentDetailComponent) },
      { path: 'documents/:id/screening', loadComponent: () => import('./components/screening-notes/screening-notes.component').then(m => m.ScreeningNotesComponent) },
      // { path: 'documents/:id/screening-results', loadComponent: () => import('./components/screening-results/screening-results.component').then(m => m.ScreeningResultsComponent) },
      { path: 'documents/:id/screening-results', loadComponent: () => import('./components/screening-results-v2/screening-results-v2.component').then(m => m.ScreeningResultsV2Component) },
      { path: 'documents/:id/email-template', loadComponent: () => import('./components/email-template/email-template.component').then(m => m.EmailTemplateComponent) },
      { path: 'profile', loadComponent: () => import('./components/profile/profile.component').then(m => m.ProfileComponent) },
      { path: 'documents/:id/fsnap', loadComponent: () => import('./components/file-snap/file-snap.component').then(m => m.FileSnapComponent) },
      { path: 'documents/:id/rsnap', loadComponent: () => import('./components/result-snap/result-snap.component').then(m => m.ResultSnapComponent) },
      { path: 'documents/:id/tsnap', loadComponent: () => import('./components/tokensnap/tokensnap.component').then(m => m.TokensnapComponent) },

      // { path: 'criteria', loadComponent: () => import('./components/criteria/criteria.component').then(m => m.CriteriaComponent) },
    ]
  },
  // { path: 'demo', loadComponent: () => import('./components/upload-demo/upload-demo.component').then(m => m.UploadDemoComponent) },
  { path: '**', redirectTo: '/manuscript-setup' }

  // { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  // {
  //   path: 'login',
  //   loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
  //   canActivate: [guestGuard]
  // },
  // {
  //   path: 'register',
  //   loadComponent: () => import('./components/register/register.component').then(m => m.RegisterComponent),
  //   canActivate: [guestGuard]
  // },
  // {
  //   path: 'dashboard',
  //   // loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent),
  //   loadComponent: () => import('./components02/dashboard/dashboard.component').then(m => m.DashboardComponent),
  //   canActivate: [authGuard]
  // },
  // {
  //   path: 'manuscript-setup',
  //   loadComponent: () => import('./components/manuscript-setup/manuscript-setup.component').then(m => m.ManuscriptSetupComponent),
  //   canActivate: [authGuard]
  // },
  // {
  //   path: 'upload',
  //   loadComponent: () => import('./components/upload/upload.component').then(m => m.UploadComponent),
  //   canActivate: [authGuard]
  // },
  // {
  //   path: 'documents',
  //   loadComponent: () => import('./components/documents/documents.component').then(m => m.DocumentsComponent),
  //   canActivate: [authGuard]
  // },
  // {
  //   path: 'documents/:id',
  //   loadComponent: () => import('./components/document-detail/document-detail.component').then(m => m.DocumentDetailComponent),
  //   canActivate: [authGuard]
  // },
  // {
  //   path: 'documents/:id/tree',
  //   loadComponent: () => import('./components/report-tree/report-tree.component').then(m => m.ReportTreeComponent),
  //   canActivate: [authGuard]
  // },

  // {
  //   path: 'profile',
  //   loadComponent: () => import('./components/profile/profile.component').then(m => m.ProfileComponent),
  //   canActivate: [authGuard]
  // },
  // {
  //   path: 'criteria',
  //   loadComponent: () => import('./components/criteria/criteria.component').then(m => m.CriteriaComponent),
  //   canActivate: [authGuard]
  // },
  // {
  //   path: 'demo',
  //   loadComponent: () => import('./components/upload-demo/upload-demo.component').then(m => m.UploadDemoComponent)
  // },
  // { path: '**', redirectTo: '/dashboard' }
];
